import { ExistsElement } from './util';
import { SetAttr, GetElement } from '@/libs/util';

import $ from 'jquery';

type UpdateElement = (
  existsElement: ExistsElement,
  updatePriceElement: UpdatePriceElement,
  selector: string,
  getElement: GetElement,
  setAttr: SetAttr,
  wcSelector: string,
  excludeTaxAttr: string,
  includeTaxAttr: string
) => (price: string, excludeTax: string, includeTax: string) => void;

type UpdatePriceElement = (selector: string, price: string) => void;

/**
 * 任意の要素のテキストを書き換える
 * 指定の要素が存在しているとき、要素の属性を更新する
 *
 * @param selector 対象要素のセレクタ
 * @param price 書き換えたいテキスト
 */
export const updatePriceElement: UpdatePriceElement = (selector, price) => {
  $(selector).each((_, ele) => {
    $(ele).text(price);
  });
};

/**
 * 指定の要素が存在しているとき、要素の属性を更新する

 * @param existsElement 要素が存在するかどうかの確認を行う関数
 * @param updatePriceElement 任意の要素のテキストを書き換える
 * @param getWcElement 要素の取得を行う関数
 * @param setAttr 要素の属性をセットする関数
 * @param selector 任意の要素のセレクタ
 * @param excludeTaxAttr 小計の属性名
 * @param includeTaxAttr 合計の属性名
 */
export const updateElement: UpdateElement = (
  existsElement,
  updatePriceElement,
  selector,
  getElement,
  setAttr,
  wcSelector,
  excludeTaxAttr,
  includeTaxAttr
) => (price, excludeTax, includeTax) => {
  const element = getElement(wcSelector);
  if (element) {
    setAttr(element, excludeTaxAttr, excludeTax.replace(/[^0-9]/g, ''));
    setAttr(element, includeTaxAttr, includeTax.replace(/[^0-9]/g, ''));
  }
  if (!existsElement(selector)) return;
  updatePriceElement(selector, price);
};
